<template>
	<div>
		<div class="container">
				<div class="home-login">
					<div class="home-box">
						<div class="home-login-form">
              <div class="home-logo">
                <img src="../assets/img/Logo.png">
              </div>
							<ul class="home-lf-box">
								<li>
									<h1> 欢迎登录 </h1>
								</li>
								<li>
									<input name="txtMemberNo" @keyup.enter="login" type="text"  maxlength="10" class="L-input-large" tabindex="1" placeholder="企业编号" v-model="CustomerNO"  />
								</li>
								<!-- <li>
									<input name="txtMemberNo" @keyup.enter="login" type="text" maxlength="10" class="L-input-large" tabindex="1" placeholder="操作员"  v-model="Oper" />
								</li> -->
								<li>
									<input name="txtMemberNo" @keyup.enter="login" type="password" maxlength="20" class="L-input-large" tabindex="1" placeholder="密码"  v-model="Pwd" />
								</li>
								<li>
									<input style='width: 180px;' name="txtMemberNo" type="text" maxlength="4" @keyup.enter="login" id="textMemberNo" class="L-input-large" tabindex="1" placeholder="验证码" v-model="captchaCode" />
									<img :src="codeImg" class="log-code" @click="getCaptcha" />
								</li>
								<li style="margin-bottom: 0px; height: 40px;">
									<label for="ckSaveAccount" class="home-btn-save">
										<input name="ckSaveAccount" type="checkbox" v-model="isCheck" tabindex="5"/>
										记住账号密码
									</label>
									<!-- <a class="home-btn-forget" @click="forgetPassword">忘记密码</a>
									<router-link to="register" class="home-btn-forget">我要注册</router-link> -->
								</li>
                <li style="margin-bottom: 0px;">
									<div @click="login" class="home-submit cursorPoint" >登录</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
	</div>
	
	 
</template>
<script>

export default {
  
  name: "Login",
  data() {
    return {
      isCheck: true,
      languageShow: false,
      CustomerNO: "",
      Oper: "",
      Pwd: "",
      codeImg: "",
      captcha: "",
      captchaCode: "",
      isFooterAsideShow: false,
      isFooterShow: true,
      iconShow1: false,
      iconShow2: false,
      iconShow3: false,
      iconShow4: false,
			lang:''
    };
  },
  methods: {
    
    getCaptcha() {
      var that = this;
      var params = {
        width: "300",
        height: "200"
      };
      that
        .getRequest({
          url: that.Api.captcha,
          params: params
        })
        .then(res => {
          that.codeImg = "data:image/jpg;base64," + res.Img;
          that.captcha = res;
          // if (res && res.IsSuccess) {
          //     that.keyResult = res.Result;
          // }
        });
    },
    forgetPassword() {
      this.error({ title: "提示", content: "请咨询电话: 0755-82318709" });
    },
    login() {
      var that = this;

      if (!that.CustomerNO) {
        that.error({ title: "提示", content: "请填写企业编号！" });
        return;
      }
      // if (!that.Oper) {
      //   that.error({ title: "提示", content: "请填写操作员！" });
      //   return;
      // }
      if (!that.Pwd) {
        that.error({ title: "提示", content: "请填写密码！" });
        return;
      }
      if (!that.captchaCode) {
        that.error({ title: "提示", content: "请填写验证码！" });
        return;
      }
      var data = {
        CustomerNO: that.CustomerNO,
        Oper: "000",
        Pwd: that.Pwd,
        CaptchaCode: that.captchaCode,
        CaptchaToken: that.captcha.Token,
        CaptchaTrackeKey: that.captcha.TraceKey
      };
      var loginInfo = {
        CustomerNO: that.CustomerNO,
        Oper: that.Oper,
        Pwd: that.Pwd
      };
      that
        .postRequest({
          url: that.Api.login,
          params: data
        })
        .then(res => {
          if (res && res.IsSuccess) {
            //登陆成功后，保存登陆信息到本地localstorage
            that.dao.set("userInfo", res.Result);

            that.setHttpHeaders(res.Result.AccessToken);
            if (that.isCheck) {
              that.dao.set("loginInfo", loginInfo);
            } else {
              that.dao.set("loginInfo", "");
            }
            that.$router.push("/");
          } else {
            that.getCaptcha();
            that.error({
              title: "提示",
              content: res.Msg || "登录出错，请重试！"
            });
          }
        });
    },
    pageScroll() {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      var top1 = document.getElementsByClassName("home-info")[0].offsetTop;
      var top2 = document.getElementsByClassName("home-info")[1].offsetTop;
      var top3 = document.getElementsByClassName("home-info")[2].offsetTop;
      var top4 = document.getElementsByClassName("home-info")[3].offsetTop;
      if (scrollTop > top1 - 450) {
        this.iconShow1 = true;
      }
      if (scrollTop > top2 - 450) {
        this.iconShow2 = true;
      }
      if (scrollTop > top3 - 450) {
        this.iconShow3 = true;
      }
      if (scrollTop > top4 - 450) {
        this.iconShow4 = true;
      }
    }
  },
  mounted() {
    this.getCaptcha();
    document.title =
      "云境";
  
   
  },
  
  created() {
		if(this.$route.query.lang){
			this.lang = this.$route.query.lang
		}
    var loginInfo = this.dao.get("loginInfo") || "";
    if (loginInfo) {
      this.CustomerNO = loginInfo.CustomerNO;
      this.Oper = loginInfo.Oper;
      this.Pwd = loginInfo.Pwd;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Login.vue